import React from "react";
import LearnersTable from "./components/LearnersTable";
import LearnerProfile from "./components/LearnerProfile";
import ActionPlanDashboard from "./ActionPlan/ActionPlanDashboard";
import { Routes, Route } from "react-router";

const Learners = () => {
  return (
    <div>
      <Routes>
        <Route path="/" element={<LearnersTable />} />
        <Route path="/profile/:learnerId" element={<LearnerProfile />} />
        <Route path="/action-plan" element={<ActionPlanDashboard />} />
      </Routes>
    </div>
  );
};

export default Learners;
